import { BindingEngine, autoinject, bindable, bindingMode, customElement } from 'aurelia-framework';
import { ValidateResult } from 'aurelia-validation';
import { Router, activationStrategy } from 'aurelia-router';
import { SaveProgress } from 'Code/Extension/Progress';
import { BaseView } from 'Common/BaseView';
import { DataService, GetPageModeEnum } from 'DataAccessLayer/Services/DataService';
import { GuidHelper } from 'Code/Helpers/GuidHelper';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { StringHelper } from 'Code/Helpers/StringHelper';
import { SystemService } from 'DataAccessLayer/Services/SystemService';
import { Toastr } from 'Code/Extension/Toastr';
import { ValidationHelper } from 'Code/Helpers/ValidationHelper';
import { Layout } from 'Common/Layout/Layout';
import { BaseCustomElement } from 'Common/BaseCustomElement';
import { promise } from 'protractor';

@customElement('review-form')
@autoinject
export class ReviewFormCustomElement extends BaseCustomElement {
    @bindable({ defaultBindingMode: bindingMode.twoWay }) extData: any = null;

    protected router: Router = null;
    private dataService: DataService = null;
    private schema: Object = null;
    private layout: Layout = null;
    private validationHelper: ValidationHelper = null;
    private validationRulesTripReview: Array<any> = [];

    private createReviewDone: boolean = false;
    private entityDataTripReview: any = {};
    private entityIdTripReview: number = null;

    private aircraftList: Array<any> = [];

    constructor(dataService: DataService, router: Router, validationHelper: ValidationHelper) {
        super();

        this.dataService = dataService;
        this.validationHelper = validationHelper;
        this.router = router;
    }

    async bind() {
        let response: any = await this.dataService.GetById('TripReview', 0);
        if (ObjectHelper.ObjectIs(response) && ObjectHelper.ObjectIs(response.data)) {
            this.entityDataTripReview = JSON.parse(JSON.stringify(response.data));
        }
        if (ObjectHelper.ObjectIs(this.extData) && StringHelper.StringIs(this.extData.TailNumber)) {
            this.entityDataTripReview.TailNumber = this.extData.TailNumber;
            await this.onTailNumberChangeEvent();
        }
        this.validationRulesTripReview = await this.validationHelper.createRules('TripReview', this.schema, this.layout, false);
    }
    private async CreateReview() {
        this.createReviewDone = await this.CreateReviewMain();

        if (this.createReviewDone == true) {
            Toastr.Success('Toastr.Done', 'Toastr.SavingFormWasSuccessful');
            this.router.navigateToRoute('dashboard');
        }
        else {
            Toastr.Error('Toastr.Oooops', 'An error occurred while saving!');
        }
        //console.log(99999, this.entityDataTripReview, createReviewDone, this.entityIdTripReview);
    }

    private async CreateReviewMain(): Promise<boolean> {
        //console.log(1);
        //const validateResult: Array<ValidateResult> = await this.validationHelper.Validate('TripReview', this.entityDataTripReview, this.validationRulesTripReview);
        //console.log(2, validateResult);
        //if (ObjectHelper.ArrayIs(validateResult)) {
        //    Toastr.ValidateError(validateResult);
        //    return false;
        //}
        //else {
        console.log(3);
        let resposne = await this.dataService.Create('TripReview', this.entityDataTripReview);
        switch (resposne['status']) {
            case 'OK': {
                Toastr.Success('Toastr.Done', 'Toastr.SavingFormWasSuccessful');
                this.entityIdTripReview = resposne['data']['EntityID'];
                return true;

            }
            default: {
                Toastr.Error('Toastr.Oooops', resposne['message'], false);
                this.entityIdTripReview = null;
                return false;
            }
        }
        //}
        return false;
    }

    private async onTailNumberChangeEvent() {
        if (StringHelper.StringIs(this.entityDataTripReview.TailNumber)) {
            await this.GetAircraftList(this.entityDataTripReview.TailNumber);
        }
        else {
            this.aircraftList = [];
            this.entityDataTripReview.Aircraft_FK = null;
            //this.ClearAircraftData();
        }
    }

    //private ClearAircraftData() {
    //    this.Aircraft_Name = null;
    //    this.Aircraft_YearOfMake = null;
    //    this.Aircraft_YearOfRefurbish = null;
    //    this.Aircraft_Wifi = null;
    //}

    async GetAircraftList(tailNumber: string): Promise<any> {
        let response: any = await this.dataService.GetFilteredSorted('Aircraft',
            0,
            10,
            null,
            {
                "TailNumber": tailNumber
            },
            null,
            '',
            null,
            null,
            1,
            [
                {
                    "ColumnName": "c_URLAircraft",
                    "Status": 1
                },
                {
                    "ColumnName": "Image_FK",
                    "Status": 1
                },
                {
                    "ColumnName": "Type_FK",
                    "Status": 1
                },
                {
                    "ColumnName": "TailNumber",
                    "Status": 1
                },
                {
                    "ColumnName": "Name",
                    "Status": 1
                },
                {
                    "ColumnName": "AircraftCategory_FK",
                    "Status": 1
                },
                {
                    "ColumnName": "MaxPax",
                    "Status": 1
                },
                {
                    "ColumnName": "Capability_FK",
                    "Status": 1
                },
                {
                    "ColumnName": "BaggageCap",
                    "Status": 1
                },
                {
                    "ColumnName": "PayloadCapacity",
                    "Status": 1
                },
                {
                    "ColumnName": "Range",
                    "Status": 1
                },
                {
                    "ColumnName": "PricingPerHour",
                    "Status": 1
                },
                {
                    "ColumnName": "AVGTaxiTime",
                    "Status": 1
                },
                {
                    "ColumnName": "TurnTime",
                    "Status": 1
                },
                {
                    "ColumnName": "CruiseSpeed",
                    "Status": 1
                },
                {
                    "ColumnName": "DoorSize",
                    "Status": 1
                },
                {
                    "ColumnName": "Wifi",
                    "Status": 1
                },
                {
                    "ColumnName": "YearOfMake",
                    "Status": 1
                },
                {
                    "ColumnName": "YearOfRefurbish",
                    "Status": 1
                },
                {
                    "ColumnName": "SafetyRating_FK",
                    "Status": 1
                },
                {
                    "ColumnName": "HomeBase",
                    "Status": 1
                },
                {
                    "ColumnName": "c_TotalScoreAvgComp",
                    "Status": 1
                },
                {
                    "ColumnName": "Id",
                    "Status": 2
                },
                {
                    "ColumnName": "CreatedBy_FK",
                    "Status": 2
                },
                {
                    "ColumnName": "Created",
                    "Status": 2
                },
                {
                    "ColumnName": "ModifiedBy_FK",
                    "Status": 2
                },
                {
                    "ColumnName": "Modified",
                    "Status": 2
                }
            ],
            null,
            false,
            GetPageModeEnum.Normal
        );
        if (StringHelper.StringIs(response.status) && response.status == 'OK') {
            if (ObjectHelper.ObjectIs(response.data) && ObjectHelper.ArrayIs(response.data.data)) {
                this.aircraftList = JSON.parse(JSON.stringify(response.data.data));
                this.entityDataTripReview.rev_AircraftName = this.aircraftList[0].Name;
                this.entityDataTripReview.rev_YearOfMake = this.aircraftList[0].YearOfMake;
                this.entityDataTripReview.rev_YearOfRefurbish = this.aircraftList[0].YearOfRefurbish;
                this.entityDataTripReview.rev_Wifi = this.aircraftList[0].Wifi;
                this.entityDataTripReview.rev_Operator = this.aircraftList[0].Operator_FK;
                this.entityDataTripReview.Aircraft_FK = this.aircraftList[0].Id;
            }
        }
        else {
            this.aircraftList = [];
            this.entityDataTripReview.Aircraft_FK = null;
            //this.ClearAircraftData();
        }
    }
}
